<script setup>
import { ref, computed } from "vue";
import whatsappIcon from "@/assets/images/company/whatsappIcon.png";
import qrCodeImage from "@/assets/images/company/qrCode.png";

const showPopup = ref(false);

const togglePopup = () => {
  showPopup.value = !showPopup.value;
};

const isMobile = computed(() => window.innerWidth <= 768);
</script>

<template>
  <div>
    <!-- WhatsApp Button -->
    <template v-if="isMobile">
      <a 
        href="https://wa.me/4915773013853" 
        target="_blank" 
        rel="noopener noreferrer"
        class="fixed bottom-4 right-4 z-50"
      >
        <img 
          :src="whatsappIcon" 
          alt="WhatsApp" 
          class="w-[75px] h-[75px] lg:w-[75px] lg:h-[75px] md:w-[60px] md:h-[60px] sm:w-[50px] sm:h-[50px] cursor-pointer transition duration-300 
          hover:drop-shadow-[0_0_15px_rgba(0,255,0,0.6)]"
        />
      </a>
    </template>
    <template v-else>
      <button 
        @click="togglePopup"
        class="fixed bottom-4 right-4 z-50"
      >
      <img 
          :src="whatsappIcon" 
          alt="WhatsApp" 
          class="w-[75px] h-[75px] lg:w-[75px] lg:h-[75px] md:w-[60px] md:h-[60px] sm:w-[50px] sm:h-[50px] cursor-pointer transition duration-300 
          hover:drop-shadow-[0_0_15px_rgba(0,255,0,0.6)]"
        />
      </button>
    </template>

    <!-- Popup -->
    <transition name="fade">
      <div 
        v-if="showPopup && !isMobile" 
        class="fixed bottom-24 right-4 bg-white p-6 rounded-lg shadow-lg w-96 text-center z-50"
      >
        <button 
          @click="togglePopup" 
          class="absolute top-2 right-4 text-2xl text-gray-600 hover:text-gray-900"
        >
          &times;
        </button>
        <h2 class="text-xl font-bold mb-2">Lass uns in Kontakt bleiben!</h2>
        <p class="text-s mb-4">Hast du noch Fragen?<br>Dann schreib uns einfach per WhatsApp!</p>
        <a 
        href="https://wa.me/4915773013853" 
        target="_blank" 
        rel="noopener noreferrer"><img :src="qrCodeImage" alt="QR Code" class="w-32 h-32 mx-auto" /></a>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
